<template>

  <body class="dx-viewport">
    <DxDataGrid ref="dataGrid" :allowColumnReordering="true" :data-source="dsSalesSources" :allowColumnResizing="true"
      key-expr="ID" :columnAutoWidth="false" :columnMinWidth="50" :columnResizingMode="'nextColumn'"
      :show-borders="true" :syncLookupFilterValues="false" :filter-sync-enabled="true" :show-row-lines="true"
      :show-column-lines="false" @selection-changed="onSelectionChanged" @row-removing="onRowRemoving">
      <DxSelection mode="single" />
      <DxFilterRow :visible="true" />
      <DxPaging :page-size="10" :page-index="0" />
      <DxPager :show-page-size-selector="true" :allowed-page-sizes="[5, 10, 20]" :show-info="true"
        :show-navigation-buttons="true" />
      <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
      <DxSorting mode="multiple" />
      <DxStateStoring :enabled="true" :filterValue="false" storage-key="SalesSources" />
      <DxToolbar>
        <DxItem>
          <template #default>
            <DxButton icon="add" type="success" @click="onAddClick" />
          </template>
        </DxItem>
        <DxItem>
          <template #default>
            <DxButton icon="refresh" @click="onRefreshClick" />
          </template>
        </DxItem>
      </DxToolbar>
      <DxEditing :allowUpdating="true" :allowDeleting="true" mode="popup">
        <DxPopup :showCloseButton="false" :width="510" :height="230">
          <DxToolbarItem :template="customTitle" />
          <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="successButtonOptions" />
          <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="dangerButtonOptions" />
        </DxPopup>
        <DxFormGrid>
          <DxItem :col-span="1" :col-count="1" item-type="group">
            <DxItem data-field="Nume" :editor-options="{ width: 470 }">
              <DxValidationRule>
                <DxRequiredRule />
              </DxValidationRule>
            </DxItem>
          </DxItem>
        </DxFormGrid>
      </DxEditing>
      <DxColumn data-field="Nume" />
    </DxDataGrid>
    <DxPopupAdd :visible.sync="isModalVisible" :showCloseButton="false" :showTitle="true" :width="530" :height="230">
      <template #title>
        <div
          style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
          Adăugare</div>
      </template>
      <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="addSaveButtonOptions" />
      <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="addCancelButtonOptions" />
      <div>
        <DxForm :formData="formData">
          <DxItem :col-span="1" :col-count="1" item-type="group">
            <DxItem dataField="Nume" :isRequired="true">
              <DxValidationRule>
                <DxRequiredRule />
              </DxValidationRule>
            </DxItem>
          </DxItem>
        </DxForm>
      </div>
    </DxPopupAdd>
  </body>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { DxButton } from 'devextreme-vue/button';
import DxPopupAdd, { DxToolbarItem } from 'devextreme-vue/popup';
import { DxItem, DxForm, DxLabel } from 'devextreme-vue/form';
import {
  DxColumn,
  DxDataGrid,
  DxFilterRow,
  DxLoadPanel,
  DxPaging,
  DxSelection,
  DxSorting,
  DxStateStoring,
  DxToolbar,
  DxEditing,
  DxPopup,
  DxItem as DxItemForm,
  DxForm as DxFormGrid,
  DxValidationRule,
  DxRequiredRule,
  DxPager,
} from 'devextreme-vue/data-grid';
import 'devextreme/dist/css/dx.light.css';
import 'devextreme/dist/css/dx.common.css';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import CRM_Services from '@/services/Comercial/CrmService';
import ResponseData from '@/types/responseData';
import notify from 'devextreme/ui/notify';
import { locale, loadMessages } from 'devextreme/localization';
import CrmSalesSources from '@/services/Comercial/CrmSalesSources';
import * as signalR from "@microsoft/signalr";
export default defineComponent({
  components: {
    DxToolbar,
    DxDataGrid,
    DxColumn,
    DxSorting,
    DxSelection,
    DxFilterRow,
    DxStateStoring,
    DxLoadPanel,
    DxPaging,
    DxButton,
    DxItem,
    DxPopup,
    DxForm,
    DxLabel,
    DxEditing,
    DxPopupAdd,
    DxToolbarItem,
    DxItemForm,
    DxFormGrid,
    DxValidationRule,
    DxRequiredRule,
    DxPager,
  },
  data() {
    return {
      connection: null as signalR.HubConnection | null,

      dsSalesSources: {} as ODataStore,
      isModalVisible: false,
      formData: {
        Nume: '',
      },
      deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",
      dataGrid: ref<DxDataGrid | null>(null),
      successButtonOptions: {
        type: 'success',
        stylingMode: 'contained',
        text: 'Salvează',
        onClick: () => {
          this.SaveEdit();
        },
      },
      dangerButtonOptions: {
        type: 'danger',
        stylingMode: 'contained',
        text: 'Închide',
        onClick: () => {
          this.onCancel();
        },
      },
      addSaveButtonOptions: {
        type: 'success',
        stylingMode: 'contained',
        text: 'Salvează',
        onClick: () => {
          this.onSave();
        },
      },
      addCancelButtonOptions: {
        type: 'danger',
        stylingMode: 'contained',
        text: 'Închide',
        onClick: () => {
          this.onCancel();
        },
      },
      customTitle() {
        return `
        <div style="background-color: #ff2c21; font-size: 16px; float: right; height:47px; width:660px; color: white; 
        font-weight: bold;  padding: 14px; padding-right: 300px;  position: relative;  left: 30px;">
          Editare 
        </div>
      `;
      },
    };
  },
  methods: {
    //cu dedicatie pentru cel mai iubit dintre bosnieci, SINISAAA!
    initSignalR() {
      this.connection = new signalR.HubConnectionBuilder()
        .withUrl(AppSetting.API_Url_ComercialSignalR, { withCredentials: true })
        .withAutomaticReconnect()
        .build();

      // evenimentul trimis de backend
      this.connection.on("EntityChanged", (entityName: string, id: number) => {
        if (entityName === "CRM_SalesSources") {
          notify('Datele au fost actualizate în timp real!', 'success', 1000);
          this.createODataContext(); // reîncarcă DataGrid-ul
        }
      });

      this.connection.start()
        .then(() => console.log("SignalR connected"))
        .catch(err => console.error("SignalR connection error:", err));
    }
    ,
    createODataContext() {
      this.dsSalesSources = new ODataStore({
        url: AppSetting.API_Url_ComercialOdata + 'CRM_SalesSources',
        key: 'ID',
        version: 4,
        beforeSend: (e) => {
          e.headers = {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt"),
          };
        },
      });
    },
    onSelectionChanged(e: any) {
      const selectedRow = e.selectedRowsData[0];
      this.$emit('selection-changed', selectedRow.ID);
    },
    onAddClick() {
      this.isModalVisible = true;
    },
    onSave() {
      if (!this.formData.Nume || this.formData.Nume.trim() === '') {
        notify('Completați câmpul obligatoriu "Nume"!', 'error', 1000);
        return;
      }
      const save = this.$refs.dataGrid?.instance;
      console.log(this.formData);
      const body = this.formData;
      CrmSalesSources.save(body).then((response) => {
        this.isModalVisible = false;
        notify('Datele au fost salvate cu succes!', 'success', 1000);
        this.formData = {
          Nume: '',
        };
      }).catch((error) => {
        console.error(error);
      });
      notify('Datele există deja!', 'error', 1000);
      this.createODataContext();
    },
    onCancel(e: any) {
      console.log("Cancel clicked");
      this.isModalVisible = false;
      const dataGrid = this.$refs.dataGrid.instance;
      if (dataGrid) {
        dataGrid.cancelEditData();
      } else {
        console.error("DataGrid instance not found");
      }

    },
    setDeleteConfirmationMessage() {
      const dataGrid = this.$refs.dataGrid.instance;
      dataGrid.option('editing', {
        allowUpdating: true,
        allowDeleting: true,
        mode: 'popup',
        texts: {
          confirmDeleteMessage: this.deleteConfirmationMessage,
          confirmDeleteTitle: "Confirmare Ștergere",

        }
      });
    },
    onClick() {
      this.isModalVisible = true;
    },

    onColumnChooserClick() {
      const dataGrid = this.$refs.dataGrid.instance;
      dataGrid.showColumnChooser();
    },
    onRefreshClick() {
      this.createODataContext();
      notify('Datele au fost actualizate cu succes!', 'success', 1000)
    },
    SaveEdit() {
      const savePromise = this.$refs.dataGrid?.instance?.saveEditData();
      savePromise.then((result) => {
        this.dataGrid?.instance?.saveEditData();
      }).catch((error) => {
        console.error(error);


      });
    },

    onRowRemoving(e: any) {
      e.cancel = new Promise((resolve) => {
        this.dataGrid?.instance?.saveEditData();
        notify('Datele au fost șterse cu succes!', 'success', 1000);
        resolve(false);
      });
    },

    getPartnersContacts() {
      CRM_Services.getPartnersContacts()
        .then((response: ResponseData) => {
          this.dsParteneriContacts = response.data;
          console.log(this.dsParteneriContacts);
        })
        .catch((e: Error) => {
          console.log(e);
        });
    },

  },
  mounted() {
    this.getPartnersContacts();
    this.createODataContext();
    this.setDeleteConfirmationMessage();
    this.initSignalR(); // <-- SignalR activat
    loadMessages({
      "ro": {
        "Yes": "Da",
        "No": "Nu",
      }
    });

    locale('ro');
  },
});
</script>

<style scoped>
.button-container {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 16px;
}

.border {
  border-radius: 8px;
}
</style>